import React from "react";
import { Button, FormFieldSet } from "..";

const AttachmentField = ({
  attachment,
  index,
  onAttachmentChange,
  onAddAttachment,
  onRemoveAttachment,
  getError,
  isRemoveDisabled,
}) => {
  return (
    <div className="grid grid-cols-3 gap-x-3 items-start pt-3">
      <FormFieldSet
        type="text"
        title=""
        placeholder="Attachment Name"
        value={attachment.attachmentName}
        onChange={(value) =>
          onAttachmentChange(attachment.id, "attachmentName", value)
        }
        error={getError(index, "attachmentName")}
      />
      <FormFieldSet
        type="text"
        title=""
        placeholder="Attachment Comments"
        value={attachment.attachmentComments}
        onChange={(value) =>
          onAttachmentChange(attachment.id, "attachmentComments", value)
        }
        error={getError(index, "attachmentComments")}
      />
      <div className="flex items-center gap-4 w-full">
        <div className="w-[80%] max-w-[80%] overflow-hidden">
          <FormFieldSet
            type="file"
            placeholder="Choose Files"
            title=""
            value={attachment.chooseFiles}
            onChange={(value) =>
              onAttachmentChange(attachment.id, "chooseFiles", value)
            }
            error={getError(index, "chooseFiles")}
          />
        </div>
        <div className="flex gap-2 w-[20%] self-start mt-7">
          <Button
            type="icon"
            size="xs"
            icon="add"
            color="black"
            onClick={onAddAttachment}
          />
          <Button
            type="icon"
            size="xs"
            icon="remove"
            color="danger"
            onClick={() => onRemoveAttachment(attachment.id)}
            disabled={isRemoveDisabled}
          />
        </div>
      </div>
    </div>
  );
};

export default AttachmentField;
